import ContactShortProfile from './ContactShortProfile'

export default ContactShortProfile
